<template>
  <section id="overview" class="hero-section">
    <div class="hero-container">
      <!-- Title & Tagline -->
      <div class="hero-text-block">
        <h1 class="hero-title">{{ t.hero.title }}</h1>
        <p class="hero-tagline">{{ t.hero.tagline }}</p>
        <p class="hero-availability">{{ t.hero.availability }}</p>
        
        <div class="hero-actions">
          <router-link to="/form" class="btn-more-info">
            {{ t.hero.learnMore }}
          </router-link>
        </div>
      </div>

      <!-- Main Visual: Exact User Provided Image (Increased Size) -->
      <div class="hero-visual-wrapper">
        <img
          src="@/assets/iphone18-pro-hero.png"
          alt="iPhone 18 Pro lying in front of chromatic PRO typography"
          class="hero-pro-img"
          loading="eager"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { useI18n } from '@/i18n';

export default {
  name: 'HeroSection',
  setup() {
    const { t } = useI18n();
    return { t };
  }
}
</script>

<style scoped>
.hero-section {
  width: 100%;
  background: #000000;
  color: #f5f5f7;
  padding-top: 90px;
  padding-bottom: 40px;
  overflow: hidden;
  text-align: center;
  position: relative;
}

.hero-container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hero-text-block {
  margin-bottom: 28px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hero-title {
  font-size: clamp(40px, 5.5vw, 58px);
  font-weight: 600;
  letter-spacing: -0.015em;
  line-height: 1.08;
  color: #f5f5f7;
  margin: 0 0 2px 0;
  font-family: var(--apple-font);
}

.hero-tagline {
  font-size: clamp(22px, 3.2vw, 28px);
  font-weight: 500;
  letter-spacing: -0.01em;
  color: #f5f5f7;
  margin: 0 0 3px 0;
}

.hero-availability {
  font-size: clamp(15px, 1.8vw, 19px);
  color: #86868b;
  font-weight: 400;
  margin: 0 0 18px 0;
}

.hero-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-more-info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0071e3;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  padding: 11px 26px;
  border-radius: 980px;
  text-decoration: none;
  transition: background-color 0.2s ease, transform 0.15s ease;
}

.btn-more-info:hover {
  background: #0077ed;
  transform: scale(1.02);
  color: #ffffff;
}

/* Visual Wrapper - Expanded for prominent hero scale */
.hero-visual-wrapper {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000000;
}

.hero-pro-img {
  width: 100%;
  height: auto;
  max-width: 1380px;
  display: block;
  object-fit: contain;
  user-select: none;
  pointer-events: none;
  transform: scale(1.06);
  transform-origin: center top;
}

@media (max-width: 768px) {
  .hero-section {
    padding-top: 110px;
    padding-bottom: 24px;
  }
  
  .hero-title {
    font-size: 38px;
  }
  
  .hero-tagline {
    font-size: 22px;
  }
  
  .hero-availability {
    font-size: 15px;
    margin-bottom: 18px;
  }
  
  .hero-text-block {
    margin-bottom: 20px;
  }

  .hero-pro-img {
    max-width: 100%;
    transform: scale(1.12);
  }
}
</style>
